import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import createStore from "./store/createStore";
import reducers from "./store/reducers";
import { ThemeProvider as MuiThemeProvider } from "common";
import CssBaseline from "@material-ui/core/CssBaseline";
import {
  createGenerateClassName,
  StylesProvider,
} from "@material-ui/core/styles";
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './utils/SSO/authConfig';

const msalInstance = new PublicClientApplication(msalConfig);
const store = createStore({}, reducers);

const generateClassName = createGenerateClassName({
  productionPrefix: "mafcarrefour-",
});

ReactDOM.render(
  <StylesProvider injectFirst generateClassName={generateClassName}>
    <MuiThemeProvider>
      <CssBaseline />
      <Provider store={store}>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </Provider>
    </MuiThemeProvider>
  </StylesProvider>,
  document.getElementById("root")
);
